export default __webpack_public_path__ + "static/media/Boton_3.d391859e.png";